function routeNotification(notification) {
    return notification.data.path;
}

function makeNotificationText(notification) {
    return notification.data.message;
}

export default {makeNotificationText, routeNotification}
